import React, { useMemo } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

export default function PDFViewer({ file, fileName, category }) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  // file is already: /api/cada/file/pdf?filename=...
  const pdfUrl = useMemo(() => {
    if (!file) return "";
    return file.startsWith("http")
      ? file
      : `${process.env.REACT_APP_PUBLIC_URL}${file}`;
  }, [file]);

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {/* Header */}
      <div
        style={{
          height: 50,
          display: "flex",
          alignItems: "center",
          padding: "0 16px",
          backgroundColor: "#fff",
          borderBottom: "1px solid #e0e0e0",
          fontWeight: 600,
        }}
      >
        {category ? `${category} : ` : ""}
        {fileName}
      </div>

      {/* Viewer */}
      <div style={{ height: "calc(100vh - 50px)" }}>
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer
            fileUrl={pdfUrl}
            plugins={[defaultLayoutPluginInstance]}
          />
        </Worker>
      </div>
    </div>
  );
}
